export default {
  content87: 'uxpay认真处理每一笔付款',
  content88: '消除繁重的手动转账和复杂的财务统计，在一个平台集成处理从付款到收款人管理的全流程工作',
  content3: '预约演示',
  content4: '参观一下',
  content5: '首页',
  // content7: '账户',
  // content8: '货币兑换',
  // content9: '收款',
  // content10: '付款',
  // content11: '境外付款',
  // content12: '收款人',
  // content13: '用户管理',
  // content14: '管理中心',
  // content15: '个人中心',
  // content16: '查看全部',
  // content17: '境外付款',
  // content18: '下载模板',
  // content19: '下载模版后，按照要求填写并上传',
  // content20: '系统会校验数据，通过后会提交付款',
  // content21: '系统会自动识别重复文件名，重复文件内容',
  // content22: '如有提示重复，请更新表格名称或者修改内容再次提交',
  // content23: '单笔付款',
  // content24: '批量付款',
  // content25: '订单号',
  // content26: '请输入订单号',
  // content27: '收款账户',
  // content28: '请输入收款账户',
  // content29: '汇款币种',
  // content30: '请选择汇款币种',
  // content31: '到账币种',
  // content32: '请选择到账币种',
  // content33: '状态',
  // content34: '请选择状态',
  // content35: '付款方式',
  // content36: '请选择付款方式',
  // content37: '中文',
  // content38: '提交时间',
  // content39: '请选择',
  // content40: '完成时间',
  // content41: '查询',
  // content42: '清空',
  // content43: '请选择收款人类型',
  // content44: '账户币种',
  // content45: '收款人类型',
  // content46: '收款账号',
  // content47: '成功',
  // content48: '创建时间',
  // content49: '操作',
  // content50: '处理中',
  // content51: '待领取',
  // content52: '取消',
  // content53: '失败',
  // content54: '成功金额',
  content89: 'uxpay实现了付款到个人收款人的自动化工作，缩减了付款时间高达90%',
  // content56: '添加收款人',
  // content57: '账号',
  // content58: '请输入企业注册地',
  content90: '收集并验证收款人信息',
  // content60: '转账中',
  content91: '实时更新付款状态',
  // content62: '账号名称',
  // content63: '请输入账号名称',
  // content64: '请输入账号',
  // content65: '收款币种',
  content92: '直接输入收款人信息到uxpay并转化为付款',
  // content67: '付款金额',
  // content68: '可用金额',
  // content69: '立即付款',
  content93: '发送全球付款，并与您的数据管理系统同步',
  // content71: '账户名',
  // content72: '交易状态',
  content94: '每笔付款在uxpay后台对应生成付款详情页面，实时更新付款状态，并明确标注失败订单的失败原因',
  content95: '内置风险管理，标记并阻止可疑账户活动',
  content96: '为大小企业打造',
  content97: '在uxpay系统进行从付款操作到付款状态跟踪、收款人管理、财务数据管理等付款全流程管理',
  content98: '自定义付款备注',
  content99: '使用API、SDK和开发工具嵌入您的应用程序或网站',
  // content79: '付款备注',
  // content80: '币种',
  // content81: '手续费',
  content100: '发送快速、灵活的付款并支持客户全球化拓展',
  content101: '一站化处理全球付款业务，快速匹配您的全球化业务',
  content102: '210+的直接银行支付国家和地区',
  content103: '绕过中介，并使用最便宜的路线选项将付款直接发送到收款人的钱包和银行账户',
  // content87: '付款至',
  content104: '收款人选择的付款方式：钱包、银行账户、支票、银行卡等',
  content105: '为您的收款人提供多种付款选项，并使付款成为您的竞争优势',
  // content90: '请选择收款人',
  // content91: '可用余额',
  // content92: '到账金额',
  // content93: '钱包',
  // content94: '银行账户',
  // content95: '支票',
  // content96: 'visa卡',
  content106: '根据客户需求定制交易费用分摊机制',
  content107: '无论您是自行承担手续费还是让收款人承担手续费，uxpay都可以为您量身定制',
  // content99: '迈出全球支付的第一步',
  // content100: '与我们预约时间，进行个性化演示并回答您的所有问题，或参加我们的互动产品之旅',
  // content102: '预约演示',
  content108: '助力您搭建与全球kol的合作关系',
  content109: '在您需要链接全球kol的时候，如何及时支付佣金是建立合作关系上的核心环节。uxpay在为全球kol提供付款服务方面有着长久且优秀的服务经验。',
  // content105: '预约演示',
  // content106: '参观一下',
  // content107: '快速、灵活的付款',
  // content108: '付款至',
  // content109: '付款方式',
  // content110: '付款金额',
  // content111: '立即付款',
  // content112: '付款方式多样化',
  // content113: '本地银行',
  content110: '无国界营销',
  content111: '在当今的互联网经济中，用户体验可以成为决定您产品接受度的一个重要影响因素。uxpay使您能够为收款人提供最佳的收款体验，同时通过高效率的付款为您建立用户信任。',
  content112: '向210多个国家和地区的影响者付款',
  content113: '多种实时到账的付款方式',
  content114: '受kol喜爱的付款方式：paypal、venmo、cash、ach、visa direct等',
  // content119: '付款金额',
  // content120: '可用余额',
  // content121: '到账金额',
  // content122: '立即付款',
  content115: '适用于规模化的付款需求，辅助您的业务增长',
  content116: '更大的业务增长意味着更多的付款需求，uxpay可以自动化付款动作，解决高频付款交易对账号和人员的工作压力和工作量',
  content117: '支持在付款信息中填写备注信息，让kol明确知道收入来源',
  content118: '一键付款到1000个kol，简化付款工作量',
  content119: '支持小金额付款，手续费远低于银行转账',
  content120: '多种D0到账的付款产品，覆盖主流钱包及账户，实时笔笔结算佣金费用',
  content121: '全球灵活用工与发薪',
  content122: 'uxpay支持您自动化处理薪酬发放，并在210多个国家支持本地化的付款方式',
  // content131: '预约演示',
  // content132: '参观一下',
  // content133: '发放成功',
  // content134: '自动发放成功',
  content123: '全球发薪和灵活用工中遇到的障碍',
  content124: '缺乏小币种国家渠道',
  content125: '小币种国家付款渠道较为稀缺，但又是用工需求较大的地区',
  content126: '汇率不透明，使得企业汇率损耗较高',
  content127: '使用电汇进行跨境付款费用高昂',
  content128: '无法实时到账',
  content129: '多数用工单位通过跨境付款支付费用，到账时间2到3天',
  content130: '新兴市场银行账户普及度不高，需要使用当地钱包付款',
  content131: '手动处理工作量繁重',
  content132: '大部分企业采用手动转账的方式进行薪酬发放，工作量大，占用人力成本',
  content133: '没有统一的付款后台对薪酬费用支出进行管理',
  content134: '提供多种付款方式，提供灵活的支付体验',
  content135: '国际银行转账',
  content136: '支付210多个国家和地区的创作者',
  content137: '电子钱包和数字支付，包括paypal、venmo、cash',
  content138: '多个小币种国家本地银行和钱包付款渠道',
  // content151: '快速、灵活的付款',
  // content152: '付款至',
  // content153: '付款方式',
  // content154: '付款金额',
  // content155: '可用金额',
  // content156: '立即付款',
  // content157: '支持多种币种',
  // content158: '付款方式多样化',
  // content159: '国际银行',
  content139: '为企业的全球化薪酬发放提供支付基础设施',
  content140: '支持在付款信息中添加付款人信息，让客户清楚薪资来源',
  content141: '简化操作流程，一键发送所有需要支付的款项',
  content142: '完善的系统功能，为客户提供付款状态的实时跟踪和及时的异常订单处理',
  content143: '有竞争力的手续费和汇率',
  content144: '一个api集成全球付款方式，大大提高渠道对接效率',
  content145: '高效快速的api对接',
  content146: '解决您目前付款环节遇到的困难',
  content147: '触达您目前付款服务商到达不了的国家和币种',
  content148: '为210多个国家的受雇佣人员提供灵活的接受薪资的付款选项',
  content149: '不需要您使用不同平台进行全球付款，uxpay帮您解决所有问题',
  content150: '通过api链接您的财务系统，方便您管理资金发放和财务统计',
  content151: '方便快捷的实现与全球供应商的合作',
  content152: '国际供应商和经销商为您的业务开辟了新通道，但通过银行系统对他们进行付款会产生复杂的材料提交要求及合规问题。uxpay可以简化您的付款流程，规避不必要的合规风险及复杂的审核材料，通过安全可靠的渠道快速帮您向全球供应商进行付款',
  // content173: '预约演示',
  // content174: '参观一下',
  // content175: '全球供应商',
  // content176: '国际供应商',
  // content177: '国际经销商',
  // content178: '收款账户',
  // content179: '收款人',
  // content180: '币种',
  // content181: '付款方式',
  // content182: '安全合规',
  content153: '一键付款至全球供应商',
  content154: '采购需要的产品不应该受到国界的限制。借助全球付款选项，uxpay允许您在任何地方使用他们喜欢的货币和付款方式向供应商付款。',
  content155: '支持全球210多个国家和地区的供应商付款',
  content156: '合理的汇率机制',
  content157: '支持小币种国家本币付款',
  // content188: '全球供应商',
  // content189: '一键付款',
  content158: '免除复杂的银行审核，并确保收款0风险',
  // content191: '充值至',
  // content192: '充值金额',
  // content193: '可用金额',
  // content194: '立即充值',
  content159: '国际银行开户和交易的复杂审核程序一直是阻碍海外采购的一个重要因素。通过uxpay，您只需要充值到我们主账户，即可由我们代您向供应商进行付款，免除所有复杂冗长的中间流程',
  content160: '充值和付款快捷简便',
  content161: '支持多币种全球付款，大部分可通过本地机构渠道实现实时到账',
  content162: '资金来源安全可信赖',
  content163: '匹配游戏行业特点的付款解决方案',
  content164: 'uxpay了解游戏行业小额高频付款交易的特点，对到账及时性的要求，以及同时对系统高并发承载能力和api的需求。无论在付款产品上、费用上、结算周期上还是在系统开发上，都做出了针对性的产品适配',
  content201: '预约演示',
  content202: '参观一下',
  content203: '付款方式',
  content204: '付款金额',
  content205: '可用余额',
  content206: '立即付款',
  content207: '到账金额',
  content165: '无论是游戏还是其他线上平台的全球化推广过程中，如何做到付款的本地化、实时性和付款方式全覆盖，都是提高用户体验的重要因素',
  content166: '付款方式全方位覆盖',
  content167: '海外钱包、虚拟银行、实体银行渠道纷繁复杂，但是uxpay不断丰富各类付款渠道，帮助您的用户用自己喜欢的方式接收付款',
  content168: '本币结算',
  content169: '对全球化的线上产品来说，本币结算是满足当地用户的必要条件，uxpay实现了主要市场的付款渠道本地化，满足绝大部分本币结算需求',
  content170: 'D0到账',
  content171: '无论是对于玩家、道具交易方、产品推广者，或者合作主播，费用的实时到账都是建立平台信任度和好感度的核心环节，uxpay理解这种关切，并致力于做到各类付款产品的实时到账',
  content172: 'uxpay深度理解客户需求，不断优化产品满足客户需要',
  content173: '全面兼容',
  content174: 'uxpay的付款api适配游戏、社交类产品、工具类产品等众多产品类型的需求',
  content175: '客户需求理解',
  content176: 'uxpay服务过众多游戏及出海应用客户，对客户需求和痛点有深刻理解',
  content177: '任意金额付款',
  content178: '通常小金额付款客户需要承担可能高于付款金额的手续费，uxpay针对小金额付款有针对性的解决方案，帮助客户优化付款成本',
  content179: '超高的付款成功率',
  content180: '我们持续优化付款环节遇到的各种问题，使得我们的付款产品有着超高的付款成功率',
  content181: '支付方式全面',
  content182: '无论是支持的国家地区，还是支持的付款方式，或是支持的币种，uxpay都能满足您的需要',
  content183: 'uxpay的付款渠道都是建立在支付机构和银行渠道的专业付款产品基础上，杜绝风险资金可能对终端用户造成的伤害',
  content6: '产品',
  content59: '一个点击，一个api，轻松全球付款',
  content60: '无论您是卖家、测评服务商、游戏发行商、社交产品还是其他线上产品，uxpay都可以支持您的自动化服务，可以帮忙您以终端用户首选的付款方式轻松向世界各地的收款人进行付款',
  content231: '预约演示',
  content232: '参观一下',
  content233: 'USD：6729    HKD：439       HKD：6729389',
  content234: '查看全部',
  content235: '境外付款/批量付款',
  content236: '商户管理系统',
  content237: '首页',
  content238: '账户',
  content239: '货币兑换',
  content240: '收款',
  content241: '付款',
  content242: '境外付款',
  content243: '收款人',
  content244: '用户管理',
  content245: '管理中心',
  content246: '个人中心',
  content247: '收款人',
  content248: '可用余额',
  content249: '付款金额',
  content250: '到账金额',
  content251: '立即付款',
  content253: '返回',
  content254: '选择收款类型',
  content255: '点击游览文件',
  content256: '仅支持文件类.xls.xlsx',
  content257: '付款总金额',
  content258: '手续费',
  content259: '总金额',
  content260: '提交',
  content261: '使用方法',
  content262: '1.下载模板后，按照要求填写并上传',
  content263: '2.系统会检验数据，通过后会提交付款',
  content264: '3.系统会自动识别重复文件名，重复文件内容',
  content265: '4.如有提示重复，请更新表格名称或者修改内容再次提交',
  content266: '下载批量付款模板',
  content267: '批次号',
  content268: '文件名称',
  content269: '付款方式',
  content270: '状态',
  content271: '上传日期',
  content272: '查询',
  content273: '清空',
  content274: '批次数量',
  content275: '付款总金额',
  content276: '手续费',
  content277: '结算金额',
  content278: '付款方式',
  content279: '备注',
  content280: '提交状态',
  content281: '操作',
  content282: 'API定制集成到您的平台中',
  content61: '随着您不断增长的业务而扩展的支出',
  content62: '随着您业务和组织的不断扩大，付款所需的工作量和人员成本也不断扩大。uxpay支付无缝集成，以自动化和简化您现有的流程和工具。通过选择uxpay，您将受益于高效的全球付款、降低运营成本以及我们简便易用的api，来增强付款能力。',
  content63: '选择单笔付款或批量付款',
  content64: '填写收款账户信息',
  content65: '多种付款方式向任何地方发送付款',
  content288: '选择付款方式',
  content66: '将数据原生同步到平台或通过API连接到其他系统',
  content67: '向任何地方发送付款，并将自动化传给uxpay',
  content68: '在一个去中心化的世界里，企业需要在全球范围内大规模付款。uxpay是一个强大的支付平台和API，我们通过api实现自动化付款，并将您与世界上210个国家的市场链接起来。',
  content69: '210多个国家和地区的灵活付款选项',
  content70: 'uxpay集成银行转账、支票账户付款、钱包付款等多种方式，提供目标市场收款人偏好的收款方式',
  content71: '简化的工作流程和支付自动化',
  content72: '定制化设计与您的业务流程相匹配的付款功能，并与您的运营系统无缝衔接',
  content73: '轻松为您的付款提供简易的充值流程',
  content74: '通过银行账户转账进行账户充值，同时支持uxpay钱包互转，轻松为代付账户注入资金',
  content75: '让您的收款人自由选择喜欢的付款方式',
  content76: '为您的付款操作提供足够的灵活性，同时在一个平台集成所有付款方式，对客户付款进行集中管理',
  content77: '付款到paypal、venmo、cash钱包',
  content78: '直接付款visa卡',
  content79: '本地银行账户',
  content303: '收款人',
  content304: '付款金额',
  content305: '可用余额',
  content306: '到账金额',
  content307: '立即付款',
  content308: '请选择付款方式',
  content82: '支持后台单笔付款',
  content83: '支持通过api传送付款请求，同步到uxpay系统',
  content84: '支持后台excel文档导入，批量付款',
  content80: 'uxpay适应您各种付款操作方式',
  content81: '付款请求支持7×24小时发起。uxpay确保您可以随时设置，让您的收款人随时接收款项',
  content85: '支持付款账单查询，并提供交易凭证',
  content86: 'uxpay 明白，从您的帐户中汇款到收款人在他们的帐户，之间存在焦虑。这就是为什么我们向您的收件人发送白标电子邮件，通知他们钱已发送。此外，您可以在uxpay后台中跟踪任何付款的实时状态，从而减轻运营团队的负担。',
  content317: '账单',
  content7: '平台',
  content10: '全球薪酬发放',
  content12: '游戏、社交及工具类产品',
  content17: '全球本地化付款服务解决方案',
  content18: '为您提供一站式的本地付款服务解决方案， 帮助您在世界范围内拓展业务以及更好的开拓新市场',
  content329: '预约演示',
  content330: '参观一下',
  content331: 'USD：6729    HKD：439       HKD：6729389',
  content332: '查看全部',
  content333: '商户管理系统',
  content334: '首页',
  content335: '账户',
  content336: '货币兑换',
  content337: '收款',
  content338: '付款',
  content339: '用户管理',
  content340: '管理中心',
  content341: '个人中心',
  content342: '付款金额',
  content343: '申请账户',
  content344: '充值申请',
  content345: '发起付款',
  content346: '货币兑换',
  content347: '提现申请',
  content348: '收款记录',
  content349: '交易统计金额',
  content350: '金额',
  content351: '笔数',
  content352: '近一周',
  content353: '近一月',
  content354: '兑换',
  content355: '收款',
  content356: '汇款',
  content357: '交易统计',
  content358: '国际汇款       24',
  content359: '收款管理        1680',
  content360: '货币兑换      348',
  content361: '我的待办',
  content362: '多币种全球收款账户',
  content19: '在全球范围内，向 210 多个国家和地区提供付款',
  content500: '向 210 多个国家和地区提供付款',
  content501: '在全球范围内，',
  content364: '收款人',
  content365: '付款金额',
  content366: '到账金额',
  content367: '立即付款',
  content20: '支付成功',
  content369: '返回',
  content21: '端到端支付自动化',
  content22: '通过一个支付系统自动完成收款人加入、付款，为收款人提供无缝体验。',
  content23: '支付',
  content26: '快速向全球任何地方发送付款',
  content27: '接入最广泛的全球支付网络，为收款人提供灵活的支付选项，并比以往更快地完成支付',
  content28: '将资金发送到210多个国家和地区',
  content29: '提供多种实时到账产品（如paypal、cash、venmo、visa direct、sepa-instant等）',
  content30: '支持主流钱包付款，避免银行收取高额手续费',
  content31: '支持api自动付款，同时支持后台excel上传批量手动付款',
  content32: '后台实时更新付款状态，及时处理异常订单',
  content380: '收款账户',
  content381: '账户名',
  content382: '交易状态    ---成功',
  content383: '付款方式',
  content384: '付款金额',
  content385: '到账金额',
  content386: '单笔手续费',
  content387: '币种',
  content388: '付款金额',
  content389: '收款账户',
  content390: '付款方式',
  content24: '系统',
  content33: 'uxpay与您的业务系统实时同步',
  content34: 'uxpay的内置集成减少了手动数据对账，防止重复错误，并提供全面付款数据信息，以更快地做出业务决策',
  content35: '支持通过api在您的系统中进行付款订单创建及付款信息集成',
  content36: '实时更新付款状态，及时处理异常订单',
  content37: '保证数据的准确性和实时性，与您的财务系统实时同步',
  content38: '强大的系统集成，匹配各种业务系统',
  content398: '已支付',
  content399: '连接QuickBooksOnline',
  content400: '您将被要求连接您的QuickBooksOnline账户并授权uxpay访问以下数据；',
  content401: '应收款信息',
  content402: '应付款信息',
  content403: '账户信息',
  content404: '同步成功',
  content405: '上传文件',
  content406: 'API',
  content39: '建立一个强大的集成化付款系统',
  content40: '通过uxpay的即用型API构建定制的支付体验。自动触发支付，在您的平台上保持最新的支付数据',
  content41: '持续进行系统功能延伸和业务模块的扩展',
  content42: '提供沙箱环境进行开发测试',
  content43: '支持完整的API文档',
  content412: '显示4,867个API日志条目',
  content413: '过滤器',
  content25: '安全',
  content44: '信任和安全贯穿于每一步',
  content45: '我们遵循全球最高标准来管理客户资金和数据。uxpay以最敏感的方式运行，我们不断优化我们的政策，以理解和防止欺诈。',
  content46: '一个强大的工具包，包括全球监视列表、风险分数、2FA访问和用户角色与权限管理系统',
  content47: '银行级别的安全性和加密、令牌化数据以及安全服务器',
  content48: '符合SOC2、GDPR、欧盟-美国隐私保护和CCPA标准',
  content421: '收件人',
  content422: '转账',
  content423: '设置',
  content424: '账户',
  content425: '您的付款已安全完成',
  content426: '平均少于5万行代码',
  content427: '简化您的架构',
  content428: '付款至',
  content429: '付款金额',
  content430: '可用金额',
  content431: '立即付款',
  content49: '一个api链接全球付款',
  content50: '强大、随时可部署的开发工具和完全灵活的API：开发人员和产品经理的首选。uxpay可以通过一行代码或API级定制集成到您的平台中。',
  content51: '我们的胜利以客户的成功来衡量',
  content52: '客户专注业务运营，无需投入资源和人力处理付款工作。uxpay协助客户处理付款工作，管理付款数据',
  content53: '3天',
  content54: '支付周期的平均减少',
  content438: '0.9',
  content55: '减少财务和管理时间',
  content440: '0.75',
  content56: '更少的钱包或转账费用',
  content442: '掌握世界各地的本地支付方式探索新的商机',
  content443: '支持的国家地区',
  content444: '电子钱包',
  content445: '实时支付',
  content446: '银行转账',
  content447: '更多付款方式',
  content448: '亚洲',
  content449: '中国大陆',
  content450: '日本',
  content451: '香港',
  content452: '越南',
  content453: '欧洲',
  content454: '英国',
  content455: '法国',
  content456: '意大利',
  content457: '德国',
  content458: '大洋洲',
  content459: '澳大利亚',
  content460: '北美洲',
  content461: '加拿大',
  content462: '美国',
  content463: '南美洲',
  content464: '巴西',
  content465: '迈出全球支付的第一步',
  content466: '与我们预约时间，进行个性化演示并回答您的所有问题，或参加我们的互动产品之旅',
  content14: '免费试用',
  content468: '预约演示',
  content57: '联系方式',
  content470: '如果您想与我们讨论我们的产品或者您希望我们了解您的需求，请联系我们',
  content58: '微信',
  content15: '邮箱',
  content16: '联系我们',
  content8: '行业解决方案',
  content9: '全球网红kol佣金付款',
  content11: '全球供应商付款',
  content185: '为您提供一站式的本地付款服务解决方案。uxpay是一个端到端的支付生态系统，让企业毫不费力地向世界各地发送快速付款',
  content184: '关于uxpay',
  content186: '我们的故事',
  content187: 'uxpay构建了一个基于云的支付平台，使企业能够以任何货币和所有主要付款方式在全球范围内向个人或公司发送付款。我们强大的支付API使企业能够访问我们庞大的全球银行和支付网络。',
  content188: 'uxpay团队有着丰富的全球支付服务经验，对金融技术和支付充满热情。我们受到所有企业都会遇到的一个问题的激励：发送付款。',
  content189: 'uxpay的愿景是通过建立一个真正的全球支付生态系统，为每个人解锁互联网的集体经济机会。我们的使命是为互联网经济建立付款基础设施。我们使企业能够接触到来自世界各地的用户和合作伙伴。',
  content190: '你可以用uxpay做什么',
  content191: '自动化发送和管理付款',
  content192: '全场景覆盖，付款无忧',
  content193: ' 一个api链接全球付款方式',
  content194: '高效的付款处理速度',
  content195: '请联系我们沟通业务情况并获取邀请码',
  content196: '立即扫码 高效了解',
  content13: '关于我们',
}